export default [
  {pot: 'prikljucek/sms/poslji?'},
  {pot: 'user/updatePhoneNumberSendConfirmationOfOldNumber?'},
  {pot: 'user/updatePhoneNumberSendConfirmationOfNewNumber?'},
  {pot: 'user/updatePhoneNumberCheckConfirmationOfNewNumber?'}
]



// WEBPACK FOOTER //
// ./src/assets/js/Enum/KriticniEndpointi.js